module.exports = __webpack_public_path__ + "static/img/long_popup_bg.a6145225.svg";